import { useCallback, useRef } from "react";

/**
 * Get the position and size of an element, and observe for changes.
 */
export const useMeasureRef = (onMeasured: (bb: DOMRectReadOnly) => void) => {
  const callbackRef = useRef(onMeasured);
  callbackRef.current = onMeasured;

  const lastBb = useRef<DOMRect>(null);

  const observerRef = useRef(
    new ResizeObserver((entries: ResizeObserverEntry[]) => {
      const bb = entries[0].target.getBoundingClientRect();
      if (
        lastBb.current &&
        bb.x === lastBb.current.x &&
        bb.y === lastBb.current.y &&
        bb.width === lastBb.current.width &&
        bb.height === lastBb.current.height
      ) {
        return;
      }
      lastBb.current = bb;
      callbackRef.current(bb);
    }),
  );

  const setRef = useCallback((node: HTMLElement) => {
    if (observerRef.current) observerRef.current.disconnect();
    if (node) observerRef.current.observe(node);
  }, []);

  return setRef;
};
